"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-pin.tsx
var PinOutline = function PinOutline(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    d: "M9.09375 11.5456L7.55743 11.5456L12.4567 16.4431V14.9074L18.5047 8.86147L15.1417 5.49971L9.09375 11.5456ZM13.1033 19.9179L9.29972 16.1157L4.06276 21.352H2.64819L2.6482 19.9376L7.88499 14.7015L4.0814 10.8993L5.43534 9.54585L8.2648 9.54585L13.727 4.08549L13.0196 3.37839L14.4343 1.96417L22.0415 9.56857L20.6268 10.9828L19.9194 10.2757L14.4573 15.736L14.4573 18.5645L13.1033 19.9179Z",
    fill: "#currentColor"
  }));
};

var _default = PinOutline;
exports.default = _default;